




















import Titlebar from './components/TitleBar.vue';
import Vue from 'vue';
export default Vue.extend({
    components: {
        Titlebar,
    },
});
